import { Component, viewChild } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  DatePipe,
  FormComponent,
  FormRowComponent,
  InputDirective,
  InputErrorsComponent,
  InputGroupComponent,
  InputGroupFieldComponent,
  InputGroupLabelComponent,
  NotificationComponent
} from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

export interface AmexAgreementFormModel {
  clientName: string,
  clientAddress: string,
  clientOccupation: string,
  clientEmployerNameAddress: string,
  clientTitlePosition: string,
  clientEmployerFunction: string
}

@Component({
  selector: 'td-wb-amex-agreement',
  templateUrl: './amex-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  imports: [
    NgTemplateOutlet,
    FormsModule,
    NotificationComponent,
    DatePipe,
    FormComponent,
    FormRowComponent,
    InputGroupComponent,
    InputGroupLabelComponent,
    InputGroupFieldComponent,
    InputDirective,
    InputErrorsComponent
  ]
})
export class AmexAgreementComponent extends AgreementsDateBaseDirective {
  protected readonly form = viewChild(FormComponent);

  formModel: AmexAgreementFormModel = {
    clientName: '',
    clientAddress: '',
    clientOccupation: '',
    clientEmployerNameAddress: '',
    clientTitlePosition: '',
    clientEmployerFunction: ''
  };

  trySubmitAndReturnModel(): AmexAgreementFormModel {
    const form = this.form();
    return form !== undefined && super.trySubmit(form) ? this.formModel : undefined;
  }
}
